import { useQuery } from "react-query";
import { configSrore } from "../configSrore";
import { ERequest, IFile, IPodspaceResult } from "../interface";
import Fetch from "../utils/fetch";

export default function useGetFiles(userGroupHash: string, page:number, size:number) {
  const key = `files-${userGroupHash}-${page}`;
  return useQuery(
    key,
    async () => {
      const response = await Fetch<IPodspaceResult<{
        list: IFile[],
        count: number
      }>>({
        url: `${configSrore.podspaceUrl}usergroups/${userGroupHash}/files?start=${page * size}&size=${size}`,
        method: ERequest.GET,
      });

      return response.result;
    },
    {
      retry: false,
      refetchOnWindowFocus: false,
    },
  );
}
